import React, { FC } from 'react';
import { Layout, Switch } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import ScrollBar from '../ScrollBar';
import { config } from '@app/utils';
import { SiderMenu } from './Menu';
import { ThemesEnum } from '@app/modules/Auth';
import './Sider.less';

export type SiderMenuItem = {
  id: string;
  icon: string;
  name: string;
  route: string;
  menuParentId?: '-1' | string;
  breadcrumbParentId?: '-1' | string;
  [key: string]: any;
};

interface SiderInterface {
  menus: SiderMenuItem[];
  theme?: ThemesEnum;
  isMobile: boolean;
  collapsed: boolean;
  onThemeChange: (theme: ThemesEnum) => void;
  onCollapseChange: (broken: boolean) => void;
}

export const Sider: FC<SiderInterface> = ({ menus, theme, isMobile, collapsed, onThemeChange, onCollapseChange }) => {
  return (
    <Layout.Sider
      width={256}
      theme={theme}
      breakpoint="lg"
      trigger={null}
      collapsible
      collapsed={collapsed}
      onBreakpoint={broken => !isMobile && onCollapseChange(broken)}
      className="sider"
    >
      <div className="brand">
        <div className="logo">
          <img alt="logo" src={config.logoPath} />
          {!collapsed && <h1>{config.siteName}</h1>}
        </div>
      </div>

      <div className="menuContainer">
        <ScrollBar
          options={{
            // Disabled horizontal scrolling, https://github.com/utatti/perfect-scrollbar#options
            suppressScrollX: true
          }}
        >
          <SiderMenu
            menus={menus}
            theme={theme}
            isMobile={isMobile}
            collapsed={collapsed}
            onCollapseChange={onCollapseChange}
          />
        </ScrollBar>
      </div>
      {!collapsed && (
        <div className="switchTheme">
          <span className="switchLabel">
            <BulbOutlined />
            Switch Theme
          </span>
          <Switch
            onChange={(checked: boolean) =>
              onThemeChange(theme === ThemesEnum.DARK ? ThemesEnum.LIGHT : ThemesEnum.DARK)
            }
            defaultChecked={theme === ThemesEnum.DARK}
            checkedChildren={'Dark'}
            unCheckedChildren={'Light'}
          />
        </div>
      )}
    </Layout.Sider>
  );
};
